export const RATING_API_URL = {
  getRatingUrl: (userId: number, rating: string) =>
    `/v1/rating?user_id=${userId}&rating=${rating}`,
  getReviewUrl: () => "/v1/feedback",
  setCandidateRating: (requestUuid: string, candidateId: string) =>
    `/v1/matching/cold_matching/${requestUuid}/${candidateId}/rating`,
};
